import React,{useMemo, useCallback, useState} from 'react';
import './assets/swich.scss';

const SwitchBtn = ({onChange, value, defaultValue=false})=>{

    const id=useMemo(()=>Math.random(),[]);

    const [stateValue, setStateValue]=useState(defaultValue);

    if(typeof value === "undefined")
        value=stateValue;

    const changeHandler=useCallback(({target})=>{
        if(onChange)
            onChange(target.checked);
        else
            setStateValue(target.checked);
    },[onChange]);

    return(
        <div className="container">
            <input className="che" id={`switch-${id}`} type="checkbox" onChange={changeHandler} checked={value}/>
            <label htmlFor={`switch-${id}`} className="radio-container"/>
        </div>
    )
};
export default SwitchBtn;